import { omit } from 'lodash';
import { BasicType } from '../constants';
import { RecursivePartial } from '../typings';
import React from 'react';
import { ISection } from '../blocks';
import MjmlBlock, { MjmlBlockProps } from '../components/MjmlBlock';

export type SectionProps = RecursivePartial<ISection['data']> &
    RecursivePartial<ISection['attributes']> & {
    children?: MjmlBlockProps<ISection>['children'];
};

export function Section(props: SectionProps) {
    return (
        <MjmlBlock
            attributes={omit(props, ['data', 'children', 'value'])}
            value={props.value}
            type={BasicType.SECTION}
        >
            {props.children}
        </MjmlBlock>
    );
}
